import { render, staticRenderFns } from "./VendorNew.vue?vue&type=template&id=c9928f70"
import script from "./VendorNew.vue?vue&type=script&lang=js"
export * from "./VendorNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports